import i18n, { ResourceLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Translations, Module } from '../XAppWrapper';

const setUpPre = (pre: string) => (
  tlEntry: [string, ResourceLanguage]
): [string, ResourceLanguage] => {
  const [lang, langTls] = tlEntry;

  const langTlsWithPre = Object.entries(langTls).reduce(
    (acc, [key, val]) => ({ ...acc, [`${pre}${key}`]: val }),
    {}
  );

  return [lang, langTlsWithPre];
};

const addToTranslations = (
  translationEntires: [string, ResourceLanguage][],
  acc: Translations
) =>
  translationEntires.reduce<any>((myAcc, [lang, langTls]) => {
    const existingLang = myAcc[lang]?.translation || {};

    return {
      ...myAcc,
      [lang]: { translation: { ...existingLang, ...langTls } }
    };
  }, acc);

export const initi18nTranslations = (modules: Module[]) => {
  const resources = modules.reduce<Translations>(
    (addedTranslations, module) => {
      if (!module.translations) return addedTranslations;

      const translationEntires = Object.entries(module.translations).map(
        setUpPre(module.id || '')
      );

      return addToTranslations(translationEntires, addedTranslations);
    },
    {}
  );

  i18n.use(initReactI18next).init({
    resources,
    lng: 'pl',
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false
    }
  });
};
